import { apiFetch } from "@/lib/api";

export interface AssemblyWorkInstructionListRow {
  assembly_kind: string;
  title: string;
  latest_revision: number | null;
  latest_approved_revision: number | null;
  pending_revision: number | null;
}

export interface AssemblyWorkInstructionRevisionRow {
  assembly_kind: string;
  revision: number;
  steps: string[];
  summary: string | null;
  description: string | null;
  created_at: string;
  submitted_at: string | null;
  approved_at: string | null;
  created_by: string | null;
  submitted_by: string | null;
  approved_by: string | null;
}

export interface AssemblyWorkInstructionPendingRow {
  assembly_kind: string;
  title: string;
  revision: number;
  summary: string | null;
  description: string | null;
  submitted_by: string | null;
  submitted_at: string | null;
}

export const ASSEMBLY_WORK_INSTRUCTIONS_QUERY_KEY = ["manufacturing", "assembly-work-instructions"] as const;

export function fetchAssemblyWorkInstructions(): Promise<{ instructions: AssemblyWorkInstructionListRow[] }> {
  return apiFetch("/api/manufacturing/assembly-work-instructions");
}

export function fetchAssemblyWorkInstructionRevisions(
  assemblyKind: string,
): Promise<{ revisions: AssemblyWorkInstructionRevisionRow[] }> {
  return apiFetch(`/api/manufacturing/assembly-work-instructions/${encodeURIComponent(assemblyKind)}/revisions`);
}

export function fetchAssemblyWorkInstructionPendingApprovals(): Promise<{ rows: AssemblyWorkInstructionPendingRow[] }> {
  return apiFetch("/api/manufacturing/assembly-work-instructions/pending-approvals");
}

export function ensureAssemblyWorkInstruction(body: { assemblyKind: string; title?: string }): Promise<{ ok: true }> {
  return apiFetch("/api/manufacturing/assembly-work-instructions/ensure", { method: "POST", body });
}

export function createAssemblyWorkInstructionRevision(body: {
  assemblyKind: string;
  steps: string[];
  summary?: string;
  description?: string;
}): Promise<{ revision: number }> {
  return apiFetch("/api/manufacturing/assembly-work-instructions/revisions", { method: "POST", body });
}

export function updateAssemblyWorkInstructionRevision(
  assemblyKind: string,
  revision: number,
  body: { steps: string[]; summary?: string; description?: string },
): Promise<{ ok: true }> {
  return apiFetch(
    `/api/manufacturing/assembly-work-instructions/${encodeURIComponent(assemblyKind)}/revisions/${String(revision)}`,
    { method: "PUT", body },
  );
}

export function submitAssemblyWorkInstructionRevision(body: {
  assemblyKind: string;
  revision: number;
}): Promise<{ ok: true }> {
  return apiFetch("/api/manufacturing/assembly-work-instructions/submit-revision", { method: "POST", body });
}

export function approveAssemblyWorkInstructionRevision(body: {
  assemblyKind: string;
  revision: number;
}): Promise<{ ok: true }> {
  return apiFetch("/api/manufacturing/assembly-work-instructions/approve-revision", { method: "POST", body });
}
